import { render, staticRenderFns } from "./UpdateSubnet.vue?vue&type=template&id=028577f3&"
import script from "./UpdateSubnet.vue?vue&type=script&lang=js&"
export * from "./UpdateSubnet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports